<template>
  <div class="receipt">
    <!-- “receipt”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @bankBranchChange="bankBranchChange"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- receipt -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/receivablesManage';
  import tableMixins from '@/common/mixins/table.js';
  // import qs from 'qs';
  import DataBaseAPI from '@/api/dataBase';
  export default {
    name: 'receiptManage',
    mixins: [tableMixins],
    computed: {
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            // 公司代码
            name: this.$t('receivablesManageList.registerColumn.registerCompanyCode'),
            prop: 'registerCompanyCode',
            type: 'select',
            options: this.companyList,
            filterable: true,
          },
          {
            name: this.$t('receivablesManageList.orderColumn.receiveStatus'),
            prop: 'receiveStatus',
            type: 'dict',
            dictType: 'receiveOrderStatus',
          },
          {
            type: 'dict',
            prop: 'accountingStatus',
            name: this.$t('saleInvoice.accountingStatus'),
            dictType: 'post_status',
          },
          {
            name: this.$t('receivablesManageList.orderColumn.docNo'),
            prop: 'docNo',
            type: 'input',
          },
          {
            // 收款日期从
            name: this.$t('receivablesManageList.search.registerStartDate'),
            prop: 'registerStartDate',
            type: 'startDaterangePicker',
          },
          {
            // 收款日期到
            name: this.$t('receivablesManageList.search.registerEndDate'),
            prop: 'registerEndDate',
            type: 'endDaterangePicker',
          },
          {
            // 认领部门
            name: '认领部门',
            prop: 'claimDepartmentNos',
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_COMPANY_DEPT_TREE,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            multiple: true,
          },
          {
            name: this.$t('receivablesManageList.orderColumn.voucherCreateDate'),
            prop: 'voucherCreateDate',
            type: 'date',
          },
          {
            // 是否代付
            name: this.$t('receivablesManageList.orderColumn.isAnotherPay'),
            prop: 'isAnotherPay',
            type: 'dict',
            dictType: 'isAnotherPay',
          },
          {
            // 代付时间从
            name: this.$t('receivablesManageList.search.anotherPayStartTime'),
            prop: 'anotherPayStartTime',
            type: 'startDaterangePicker',
          },
          {
            // 代付时间到
            name: this.$t('receivablesManageList.search.anotherPayEndTime'),
            prop: 'anotherPayEndTime',
            type: 'endDaterangePicker',
          },
          {
            // 财务审核状态
            name: this.$t('receivablesManageList.orderColumn.financeAuditStatus'),
            prop: 'financeAuditStatus',
            type: 'dict',
            dictType: 'financeAuditStatusForRecieve',
          },
          {
            // 收款登记号
            name: this.$t('receivablesManageList.orderColumn.registerNo'),
            prop: 'registerNo',
            type: 'input',
          },
          {
            // 收款方式
            type: 'dict',
            dictType: 'receiveMethod',
            name: this.$t('receivablesManage.basicInfo.receiveMethod'),
            prop: 'receiveMethod',
          },
          {
            // 票据号
            name: '票据号',
            prop: 'billCode',
            type: 'input',
          },
          {
            // 制单人
            prop: 'createPersonNo',
            type: 'searchTableSpec',
            name: '制单人',
            searchType: 'personnel',
            isMultiple: true,
            propCode: 'personNo',
            propName: 'personName',
          },
          {
            // 收款银行
            type: 'searchTableSpec',
            prop: 'receiveBankNo',
            name: this.$t('receivablesManage.basicInfo.receiveBankNo'),
            searchType: 'bankAccountBranchName',
            extraData: {
              bankAccountStatus: '001',
              companyCode: this.query.registerCompanyCode,
            },
            isMultiple: true,
            changeMethod: 'bankBranchChange',
          },
          /* { // 收款银行
          name: '收款银行', 
          prop: "receiveBankName", 
          type: "input",
        }, */
          {
            // 信用证号
            name: '信用证号',
            prop: 'clCode',
            type: 'input',
          },
          {
            // 客户名称
            prop: 'customerNo',
            type: 'searchTableSpec',
            name: '客户名称',
            searchType: 'supplier',
            extraData: {
              partnerTypes: 'HZHB03,HZHB01',
              companyCode: this.query.registerCompanyCode, //公司
            },
            isMultiple: true,
          },
          {
            //收款金额开始结束
            type: 'inputRange',
            prop: ['originReceiveMoneyMinAmount', 'originReceiveMoneyMaxAmount'],
            precision: 2, //精度，就是保留几位小数,默认两位
            max: 99999999999999.99,
            name: '收款金额',
          },
          {
            // 付款单位
            prop: 'payerCode',
            type: 'searchTableSpec',
            searchType: 'partner',
            isMultiple: true,
            name: this.$t('receivablesManage.receivablesInfo.payerCode'),
            extraData: {
              companyCode: this.query.registerCompanyCode,
              partnerTypes: 'HZHB01,HZHB02,HZHB03', // 客户、供应商、合作伙伴
            },
          },
          {
            // 币种
            type: 'dict',
            prop: 'receiveInfoCurrencyCode',
            name: this.$t('paymentList.table.currencyCode'),
            dictType: 'all_currency',
          },
          {
            prop: 'voucherNo',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
        ];
      },
    },
    data() {
      return {
        footerTotalCols: {
          amount: [
            'originReceiveMoneyAmount',
            'originProformaInvoiceAmount',
            'originDomesticBankDeductFee',
            'originForeignBankDeductFee',
          ],
        }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        exportAction: API.EXPORT_COLLECTIONORDER,
        query: {
          registerCompanyCode: null, // 公司代码
          receiveStatus: null,
          accountingStatus: null,
          docNo: null,
          registerStartDate: null,
          registerEndDate: null,
          claimDepartmentNos: null,
          voucherCreateDate: null,
          isAnotherPay: null, // 是否代付
          anotherPayStartTime: null, // 代付时间从
          anotherPayEndTime: null, // 代付时间到
          financeAuditStatus: null, // 是否财务审核通过
          registerNo: null,
          receiveMethod: null, //收款方式
          billCode: null, //票据号
          createPersonNo: null, //制单人
          receiveBankNo: null, //收款银行
          clCode: null, //信用证号
          customerNo: null, //客户名称
          originReceiveMoneyMinAmount: null, //收款金额开始
          originReceiveMoneyMaxAmount: null, //收款金额结束
          payerCode: null, //付款单位
          voucherNo: null,
          searchOrderItems: [],
        },
        columnListDefault: [
          {
            // 复选框
            type: 'checkbox',
            width: '50',
            fixed: 'left',
          },
          {
            // 收款单号
            field: 'docNo',
            title: 'receivablesManageList.orderColumn.docNo',
            width: 150,
            fixed: 'left',
            sortable: true,
          },
          {
            field: 'registerCompanyName',
            title: '公司',
            width: 180,
            fixed: 'left',
          },
          {
            // 收款日期
            field: 'registerDate',
            title: 'receivablesManageList.orderColumn.registerDate',
            width: 120,
            sortable: true,
          },
          {
            // 创建日期
            field: 'voucherCreateDate',
            title: 'receivablesManageList.orderColumn.voucherCreateDate',
            width: 120,
            sortable: true,
          },
          {
            // 制单人
            field: 'createPersonName',
            title: 'receivablesManageList.orderColumn.createPersonName',
            width: 120,
          },
          {
            // 收款方式
            field: 'receiveMethod',
            title: 'receivablesManageList.orderColumn.receiveMethod',
            width: 120,
            dictType: 'receiveMethod',
          },
          {
            // 来源
            field: 'receiveResource',
            title: 'receivablesManageList.orderColumn.receiveResource',
            width: 120,
            dictType: 'receiveResource',
          },
          {
            // 收款银行
            field: 'receiveBankName',
            title: 'receivablesManageList.orderColumn.receiveBankName',
            width: 120,
          },
          {
            // 收款银行账号
            field: 'receiveBankAccount',
            title: 'receivablesManageList.orderColumn.receiveBankAccount',
            width: 120,
          },
          {
            // 付款单位
            field: 'payerName',
            title: 'receivablesManageList.orderColumn.payerName',
            width: 120,
          },
          {
            // 是否代付(新增)
            field: 'isAnotherPay',
            title: 'receivablesManageList.orderColumn.isAnotherPay',
            dictType: 'isAnotherPay',
          },
          {
            // 代付时间(新增)
            field: 'anotherPayTime',
            title: 'receivablesManageList.orderColumn.anotherPayTime',
            sortable: true,
          },
          {
            // 是否财务审核通过(新增)
            field: 'financeAuditStatus',
            title: 'receivablesManageList.orderColumn.financeAuditStatus',
            dictType: 'financeAuditStatusForRecieve',
          },
          {
            // 付款银行
            field: 'payBankName',
            title: 'receivablesManageList.orderColumn.payBankName',
            width: 120,
          },
          {
            // 付款银行账号
            field: 'payBankAccount',
            title: 'receivablesManageList.orderColumn.payBankAccount',
            width: 120,
          },
          {
            // 银行流水号
            field: 'bankFlowNo',
            title: 'receivablesManageList.orderColumn.bankFlowNo',
            width: 120,
          },
          {
            // 币种
            field: 'receiveInfoCurrencyName',
            title: 'receivablesManageList.registerColumn.receiveInfoCurrencyCode',
            width: 120,
          },
          {
            // 收款金额
            field: 'originReceiveMoneyAmount',
            title: 'receivablesManageList.orderColumn.originReceiveMoneyAmount',
            width: 120,
            format: 'formatAmount',
            sortable: true,
          },
          {
            // 形式发票金额
            field: 'originProformaInvoiceAmount',
            title: 'receivablesManageList.orderColumn.originProformaInvoiceAmount',
            width: 120,
            format: 'formatAmount',
            sortable: true,
          },
          {
            // 国内银行扣费
            field: 'originDomesticBankDeductFee',
            title: 'receivablesManageList.orderColumn.originDomesticBankDeductFee',
            width: 120,
            format: 'formatAmount',
            sortable: true,
          },
          {
            // 国外银行扣费
            field: 'originForeignBankDeductFee',
            title: 'receivablesManageList.orderColumn.originForeignBankDeductFee',
            width: 120,
            format: 'formatAmount',
            sortable: true,
          },
          {
            // 收款登记号
            title: this.$t('receivablesManageList.orderColumn.registerNo'),
            field: 'registerNo',
            width: 150,
            sortable: true,
          },
          {
            // 摘要
            field: 'summary',
            title: 'receivablesManageList.orderColumn.summary',
            width: 120,
          },
          {
            // 收款状态
            field: 'receiveStatus',
            title: 'receivablesManageList.orderColumn.receiveStatus',
            width: 120,
            dictType: 'receiveOrderStatus',
            fixed: 'right',
          },
          {
            // 收款单过账状态
            field: 'accountingStatus',
            title: 'receivablesManageList.orderColumn.accountingStatus',
            width: 120,
            dictType: 'post_status',
            fixed: 'right',
          },
          {
            field: 'voucherNo',
            title: '凭证号',
            visible: true,
          },
          {
            // 代付过账状态
            field: 'anotherPayAccountStatus',
            title: 'receivablesManageList.orderColumn.anotherPayAccountStatus',
            width: 120,
            dictType: 'post_status',
            fixed: 'right',
          },
        ],
        companyList: [],
      };
    },
    mounted() {
      this.getData();
      this.getCompany();
      this.getButtonList();
    },
    methods: {
      // 获取列表数据
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        params.customerNo =
          params.customerNo && params.customerNo[0] ? params.customerNo[0].partnerCode : '';
        params.createPersonNo =
          params.createPersonNo && params.createPersonNo[0]
            ? params.createPersonNo[0].personNo
            : '';
        params.payerCode = params.payerCode ? params.payerCode[0].partnerCode : null;
        params.claimDepartmentNos = params.claimDepartmentNos
          ? params.claimDepartmentNos.split(',')
          : null;
        let res = await this.$axios.post(API.QUERY_COLLECTIONORDER_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      // 排序
      sortChangeEvent({ property, order }) {
        this.query.searchOrderItems = [
          { column: property.replace(/([A-Z])/g, '_$1').toLowerCase(), asc: order == 'asc' },
        ];
        this.getData();
      },
      bankBranchChange(val) {
        console.log(11);
        val = val.val;
        if (val && val.length > 0 && val[0].branchName) {
          this.query.receiveBankName = val[0].branchName;
          this.query.receiveBankNo = val[0].branchCode;
          this.query.receiveBankAccount = val[0].bankAccountNum;
        } else {
          this.query.receiveBankName = null;
          this.query.receiveBankNo = null;
          this.query.receiveBankAccount = null;
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      // 按钮
      chooseClick(type) {
        if (type === 'add' || type === 'edit') {
          let [name, query] = ['addReceipt', {}];
          if (type == 'edit') {
            if (this.multipleSelection.length != 1) {
              return this.tips('onlyOneSelectData', 'warning');
            }
            if (
              this.multipleSelection[0].receiveResource != '04' ||
              this.multipleSelection[0].accountingStatus != 'notgenerate'
            ) {
              return this.tips('noEditByReceipt', 'warning');
            }
            [name, query] = ['editReceipt', { id: this.multipleSelection[0].id }];
          }
          this.toPath(name, query);
        } else if (type === 'del') {
          this.handleDel();
        } else if (type === 'export') {
          // 导出
          this.commonExport();
        } else if (type === 'generateCredentials') {
          this.batchGenarateVoucher(
            'AE_AR_RECEIPTS',
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'batchSyncVoucher') {
          this.batchSyncVoucher(
            API.BATCH_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'batchSignSyncVoucher') {
          this.batchSyncVoucher(
            API.BATCH_SIGN_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        }
      },
      // 删除
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'warning');
        }
        let canDelitems = [];
        this.multipleSelection.map((i) => {
          if (i.accountingStatus == 'notgenerate' && i.receiveStatus == '04') {
            // 生成凭证前且收款状态是已保存状态
            canDelitems.push(i);
          }
        });
        if (canDelitems.length == 0) {
          return this.tips('noCanDelSelectOrderData', 'warning');
        }
        let items = canDelitems.map((i) => i.id);
        let message = '';
        if (canDelitems.length !== this.multipleSelection.length) {
          message = this.$t('receivablesManageList.message.hasCannotDelOrderTip');
        }
        this.$confirmAction(this.$t('confirm.delete'), message)
          .then(() => {
            this.commonRequest('DELETE_COLLECTIONORDER', items);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      commonRequest(apiName, params) {
        this.$axios.post(API[apiName], params).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 列表双击
      dblclickEvent(value) {
        this.toPath('detailsReceipt', {
          id: value.row.id,
          companyCode: value.row.registerCompanyCode,
        });
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`receivablesManageList.message.${info}`),
          type: type,
        });
      },
      // 跳转路径
      toPath(name, query) {
        let path = {
          path: `/capital/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
